// themeConfig.js
export const themes = {
  light: {
    mode: "light",
    primary: "#1976d2",
    secondary: "gray",
    disabled: "#ccc",
    background: "#f8f9fa",
    background2: "#ffffff",
    border: "#d3d3d3",
    border2: "#e0e0e0",
    borderHover: "#a0a0a0",
    borderHover2: "#bfbfbf",

    labelBgSuccess: "#e9f7ef",
    labelBgWarning: "#fffbea",
    labelBgDanger: "#fff3f3",
    labelBgMuted: "#f9f9f9",

    labelTextSuccess: "#1e4620",
    labelTextWarning: "#663c00",
    labelTextDanger: "#b71c1c",
    labelTextMuted: "#666666",

    labelLineSuccess: "#92d14f",
    labelLineWarning: "#f1c40f",
    labelLineDanger: "#e74c3c",
    labelLineMuted: "#cccccc",

    textColor: "#000000",
    textColorInv: "#ffffff",
    textMuted: "#666666",
    textMutedInv: "#999999",
  },

  dark: {
    mode: "dark",
    primary: "#90caf9",
    secondary: "#ce93d8",
    disabled: "#666",
    background: "#121212",
    background2: "#1e1e1e",
    border: "#333333",
    border2: "#2c2c2c",
    borderHover: "#555555",
    borderHover2: "#666666",

    labelBgSuccess: "#234c36",
    labelBgWarning: "#4c4421",
    labelBgDanger: "#4c1c1c",
    labelBgMuted: "#2a2a2a",

    labelTextSuccess: "#a8ffdd",
    labelTextWarning: "#fff6c2",
    labelTextDanger: "#ffb3b3",
    labelTextMuted: "#bbbbbb",

    labelLineSuccess: "#66bb6a",
    labelLineWarning: "#f4d03f",
    labelLineDanger: "#e57373",
    labelLineMuted: "#777777",

    textColor: "#ffffff",
    textMuted: "#bbbbbb",
  },

  purple: {
    mode: "purple",
    primary: "#7b1fa2",
    secondary: "#ba68c8",
    disabled: "#a7a7a7",
    background: "#1f163a",
    background2: "#100021",
    border: "#503a7c",
    border2: "#5f3e9e",
    borderHover: "#5f3e9e",
    borderHover2: "#9882c2",

    labelBgSuccess: "#244037",
    labelBgWarning: "#4a5400",
    labelBgDanger: "#360101",
    labelBgMuted: "#303030",

    labelTextSuccess: "#92d14f",
    labelTextWarning: "#fbeec4",
    labelTextDanger: "#b71c1c",
    labelTextMuted: "#c7b5d9",

    labelLineSuccess: "#92d14f",
    labelLineWarning: "#f1c40f",
    labelLineDanger: "#e74c3c",
    labelLineMuted: "#cccccc",

    textColor: "#ffffff",
    textColorInv: "#000000",
    textMuted: "#c7b5d9",
  },

  contrast: {
    mode: "contrast",
    primary: "#000000",
    secondary: "#ffffff",
    disabled: "#999",
    background: "#ffff00",
    background2: "#fff9cc",
    border: "#000000",
    border2: "#333333",
    borderHover: "#444444",
    borderHover2: "#666666",

    labelBgSuccess: "#c8ff00",
    labelBgWarning: "#ffee00",
    labelBgDanger: "#ff7777",
    labelBgMuted: "#f0f0f0",

    labelTextSuccess: "#000000",
    labelTextWarning: "#000000",
    labelTextDanger: "#000000",
    labelTextMuted: "#333333",

    labelLineSuccess: "#000000",
    labelLineWarning: "#222222",
    labelLineDanger: "#550000",
    labelLineMuted: "#888888",

    textColor: "#000000",
    textMuted: "#333333",
  },
};
